import React from 'react';
import cl from "./SurveysPageMenuItem.module.css";

const SurveysPageMenuItem = ({id, title, selected, onClick}) => {
    return (
        <button
            className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
            onClick={onClick}
        >
            <span className={cl.title}>{title}</span>
        </button>
    );
};

export default SurveysPageMenuItem;